import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {
  1: {
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P60-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    maxLength: 1,
    textAlign: 'center',
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page60/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page60/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page60/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page60/E1/3.jpg', input: true, answer: "5" },
        { url: 'img/FriendsPlus/Page60/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page60/E1/5.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page60/E1/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page60/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page60/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page60/E1/9.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page60/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page60/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page60/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page60/E1/13.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page60/E1/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page60/E1/15.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P60-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 5,
    exerciseKey: 'img/FriendsPlus/Page60/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page60/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page60/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page60/E2/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page60/E2/4.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page60/E2/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page60/E2/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page60/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page60/E2/8.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page60/E2/9.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page60/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page60/E2/11.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page60/E2/12.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page60/E2/13.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page60/E2/14.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page60/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page60/E2/16.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page60/E2/17.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page60/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page60/E2/19.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page60/E2/20.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page60/E2/21.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page60/E2/22.jpg' },
      ],


    ]
  },



}
export default json;